import Cmd from '../utils/Cmd'
import onInit from '../utils/onInit'
const {assign} = Object

const findWrapper = ($element) => {
  const w = $element.parents(".form-group")
  if (w.length == 0) {
    return $element.parents("label")
  } else {
    return w
  }
}


const findHelpBlock = ($element) => findWrapper($element).find(".help-block")

const insertHelpBlock = ($element) =>
  findWrapper($element)
    // .find(".input-group, input, select, .algolia-autocomplete")
    // .first()
    .append("<span class='help-block'></span>")



// type FieldState = { errors: Array String, touched: Boolean, value: String }


const init = (fieldState) => {
  return [
    assign({}, { touched: false, focus: false, errors: [], value: "", validating: false }, fieldState),
    Cmd.none
  ]
}

const update = (fieldState, action) => {
  switch (action.type) {
    case "CHANGE":
      return [
        Object.assign({}, fieldState, { value: action.value, errors: []}),
        Cmd.none
      ]
    case "FOCUS":
      return [
        assign({}, fieldState, { focus: true }),
        Cmd.none
      ]
    case "BLUR":
      return [
        Object.assign({}, fieldState, { focus: false, touched: true, value: action.value }),
        Cmd.none
      ]
    case "START_VALIDATION":
      return [
        assign({}, fieldState, { validating: true }),
        Cmd.none
      ]
    case "FINISH_VALIDATION":
      return [
        assign({}, fieldState, { validating: false, errors: action.errors }),
        Cmd.none
      ]
    default:
      return [fieldState, Cmd.none]
  }
}

/* TODO: Get value and set value are not entirely correct
 * because they wont support a list of checkboxes with the same name (select
 * multiple checkboxes)
 */
const getValue = (type) => ($element) => {
  if (type === 'checkbox') {
    return $element.prop('checked')
  } else if (type === 'radio') {
    const name = $element.attr('name')
    const selector = name + ":checked"
    return $(selector).val()
  } else {
    return $element.val()
  }
}

const setValue = (type) => ($element, value) => {
  if (type === 'radio') {
    $element.val( (value instanceof Array) ? value : [ value ])
  } else if (type === 'checkbox') {
    $element.prop('checked', value)
  } else {
    $element.val(value)
  }
}

const view = ($elements,  state, dispatch) => {
  $elements.each(function () {
    var $element = $(this)
    const type = $element.attr('type')

    const getVal = getValue(type)
    const setVal = setValue(type)

    // don't overwrite the value when the field is focused
    if (!state.focus) {
      setVal($element, state.value)
    }

    if (type !== 'hidden') {
      onInit($element, () => {
        // in bootstrap help block is used to display errors,
        // help block can exist, if there were errors rendered by the server / formtastic
        if (findHelpBlock($element).length === 0) {
          insertHelpBlock($element)
        }

        $element.on('blur', (e) => dispatch({ type: 'BLUR', value: getVal($(e.target))}))
        $element.on('focus', (e) => dispatch({ type: 'FOCUS' }))
        $element.on('change', (e) => dispatch ({ type: 'CHANGE', value: getVal($(e.target))}))
      })

      const $helpBlock = findHelpBlock($element)
      const $wrapper = findWrapper($element)

      if (state.validating) {
        $helpBlock.html("<i class='icon-spinner icon-spin'></i>")
      } else if (state.touched) {
        if (state.errors.length > 0) {
          $wrapper.removeClass('success')
          $wrapper.addClass('error has-error')
          $helpBlock.html(state.errors.join(", "))
        } else {
          $wrapper.removeClass('error').removeClass('has-error')
          $wrapper.addClass('success')
          $helpBlock.html('<i class="icon-ok icon-ok"></i>')
        }
      }
    }
  })
}

export default {
  init: init,
  update: update,
  view: view
}
